import { Collection } from 'modules/core/lib/mobx-rest'

import ExpensesCategoryContractsTaxonomy from 'modules/payroll_bundle/store/models/ExpensesCategoryContractsTaxonomy'

export class ExpensesCategoriesContractsTaxonomies extends Collection<ExpensesCategoryContractsTaxonomy> {
  model() {
    return ExpensesCategoryContractsTaxonomy
  }

  findByExpensesCategoryAndTaxonomies({
    expensesCategoryId,
    taxonomyIds,
  }: {
    expensesCategoryId: string
    taxonomyIds: number[]
  }) {
    return this.find(
      (ecct) =>
        ecct.attributes.expenses_category_id === expensesCategoryId &&
        taxonomyIds.includes(ecct.attributes.contracts_taxonomy_id)
    )
  }

  async existingTaxonomies(): Promise<string[]> {
    const value = await this.rpc('exists', {}, { method: 'GET' })

    return value
  }
}

export default new ExpensesCategoriesContractsTaxonomies()
